import React, { useContext } from "react";
import classnames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquare, faCheckSquare } from "@fortawesome/free-regular-svg-icons";

import { ProductsContext } from "../../../contexts/attributes";

const BulkCheck = ({ codingWipKey }) => {
    const { products, update } = useContext(ProductsContext);
    const value = products[codingWipKey].shouldBulk;
    const icon = value ? <FontAwesomeIcon icon={faCheckSquare} /> : <FontAwesomeIcon icon={faSquare} />;
    const onChange = () => {
        update(codingWipKey, "shouldBulk", !value);
    };

    return (
        <div className={classnames("bulk-check", { "-active": !!value })} onClick={onChange}>
            {icon}
        </div>
    );
};

export default BulkCheck;
